import i18n from '@/utils/i18n';
import { EMPTY_VALUE_PLACEHOLDER } from '@/experiences/sales-portal/domain/prospects/screens/prospects/constants';
import { formatWeeklyValue } from '@/experiences/sales-portal/domain/prospects/screens/prospects/blocs/utils/prospect-value-utils';
import type {
  ManagerRepRowData,
  ManagerRepSummaryQueryRow,
  ManagerRepTimeRange,
} from '@/experiences/sales-portal/domain/prospects/screens/prospects/types';

type RangeMetrics = ManagerRepSummaryQueryRow['mtd'];

const formatConversionRate = (rate: RangeMetrics['conversion_rate']): string =>
  rate === null || rate === undefined
    ? EMPTY_VALUE_PLACEHOLDER
    : `${Math.round(rate * 100)}%`;

const formatAvgConversionDays = (
  days: RangeMetrics['average_conversion_days'],
): string =>
  days === null || days === undefined
    ? EMPTY_VALUE_PLACEHOLDER
    : i18n.t('sales_portal.prospects.manager.days_short', { count: days });

export function transformToManagerRepRowData(
  rows: ManagerRepSummaryQueryRow[],
  timeRange: ManagerRepTimeRange,
): ManagerRepRowData[] {
  return rows.map((row) => {
    const metrics = row[timeRange];

    return {
      avgConversionDays: metrics.average_conversion_days ?? undefined,
      avgConversionDaysDisplay: formatAvgConversionDays(
        metrics.average_conversion_days,
      ),
      conversionRate: metrics.conversion_rate ?? undefined,
      conversionRateDisplay: formatConversionRate(metrics.conversion_rate),
      noteCount: metrics.note_count,
      repName: row.employee_name,
      repUUID: row.employee_id,
      weeklyValueDisplay: formatWeeklyValue(
        metrics.converted_weekly_estimated_value_in_micros,
        row.currency_code,
      ),
      weeklyValueInMicros:
        metrics.converted_weekly_estimated_value_in_micros ?? undefined,
    };
  });
}
